//We can manipulate Gatsby LINK component here. Check for internal links.
import React from "react";
import { Link as GatsbyLink } from "gatsby";

const externalLinks = ["help.mod-lighting.com", "youtube.com", "youtu.be", "instagram"];

const domainRegex = new RegExp(`^(https?:\\/\\/)?(www\\.)?(${externalLinks.join("|").replace(/\./g, "\\.")})`, "i");

const Link = ({ children, to, activeClassName, partiallyActive, isTargetBlank = false, ...other }) => {
	// If the link is internal, use Gatsby Link component
	const internal = /^\/(?!\/)/.test(to);
	const shouldOpenInNewTab = isTargetBlank || domainRegex.test(to);

	if (internal && !shouldOpenInNewTab) {
		return (
			<GatsbyLink to={to || ""} activeClassName={activeClassName} partiallyActive={partiallyActive} {...other}>
				{children}
			</GatsbyLink>
		);
	}

	// If the link is external, use <a> tag
	return (
		<a href={to}
			{...other}
			target={shouldOpenInNewTab ? "_blank" : undefined}
			rel={shouldOpenInNewTab ? "noreferrer" : undefined}
		>
			{children}
		</a>
	);
};
export default Link;
